import React, { useEffect, useState, useRef, useCallback } from "react";
import { useQuery } from "react-query";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import * as yup from "yup";
import {
  SecondaryButton,
  Title,
  TextField,
  TextAreaInput,
  ActionButton,
  ErrorText,
  IconButton,
} from "../../atoms";
import { ActionButton2 } from "../../atoms/ActionButton2/ActionButton2";

import VariantItem from "../VariantItem/VariantItem";
import VariantEdit from "../VariantEdit/VariantEdit";
import TraitsInput from "../TraitEdit/TraitsInput";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { ErrorWrapper, ConfirmationContent } from "../../molecules";
import { AnalyticsService } from "../../../utils/Analytics";
import Select from "react-select";
import validator from "../../../utils/validations";
import ImageUploading from "react-images-uploading";
import { apiGet, apiPost, apiDelete, Messages } from "../../../utils";
import { getListFiles, toVideoData } from "../../../utils/fileUtils";
import { optionsByCategory, bespokeBatOptions } from "../AddProductForm/variantData";
import {
  DELETEPRODUCT,
  UPDATEPRODUCT,
  GETFIELDSBYCATEGORYNAME,
} from "../../../api/apiConfig";
import {
  getProductModels,
  getProductWeights,
  getProductGrades,
  getProductMetaFields,
  getProductDescription,
} from "../../../api/api";
import { Container } from "../../DragDropCard/DragDropCard";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ImageResizer from "../ImageResizer/ImageResizer";
import CircularProgress from '@mui/material/CircularProgress';
import { useMediaQuery } from "react-responsive";
import { Stack } from "@mui/material";

const VideoLayout = (props) => {
  const { className, overlayClass, src, onClick, idx } = props;
  return (
    <div className={className}>
      <div className={overlayClass} />
      <video controls className="formImg">
        <source src={src} type="video/mp4"></source>
      </video>
      <IconButton onClick={() => onClick(idx)} className="imageRemoveCls" />
    </div>
  );
};

const hasFormErrors = (errors) => {
  return Object.keys(errors).length > 0;
};

const batCategories = ["Bespoke Cricket Bats", "Workshop Cricket Bats"];
const bespokeCategoryName = "Bespoke Cricket Bats";


export const EditProductForm = ({
  onCancelClick,
  title,
  value,
  productQuantity,
  productOptions,
  productDescription,
  productImages,
  productVideos,
  id,
  setShowProduct,
  getProducts,
  productCategories,
  productCategory,
  setShowList,
  tryBeforeYouBuy,
  isExclusive,
  weightVal,
  weightUnitVal,
  modelId,
  gradeId,
  variants: productVariants,
  isTopDeal,
  Traits
}) => {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const userName = localStorage.getItem("userName");

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })
  const prodCategories =
    productCategories &&
    productCategories.map((m) => ({
      value: m.id,
      label: m.name,
    }));

   
  const [selectedVariant, setSelectVariant] = useState(null);

  const [state, setState] = useState({
    description: productDescription,
    productName: title,
    productPrice: String(value),
    quantity: productQuantity,
    images: productImages,
    videos: productVideos,
    productId: id,
    productWeight: weightVal,
    productWeightUnit: weightUnitVal,
    isLoading: false,
    selectedCategory: productCategory,
    isExclusive: isExclusive,
    options: productOptions,
    fields: bespokeBatOptions,
    variants: productVariants,
    selectedWeight: null,
    selectedGrade: null,
    hasPriceChange: false,
    
  });

  const {
    description,
    productName,
    productPrice,
    quantity,
    images,
    videos,
    productId,
    isLoading,
    selectedCategory,
    fields,
    options,
    productWeight,
    productWeightUnit,
    variants,
    customModel,
    selectedModel,
    selectedWeight,
    customGrade,
    selectedGrade,
    hasPriceChange,
    
  } = state;

  const originalString = description ? description : "";
  const strippedString = originalString.replace(/(<([^>]+)>)/gi, "");

  const [nameError, setNameError] = useState("");
  const [descError, setDescError] = useState("");
  const [priceError, setPriceError] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const [imageError, setImageError] = useState({});
  const [invalidData, setInvalidData] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [weightError, setWeightError] = useState("");
  const [ounces, setOunces] = useState(0);
  const [videoErr, setVideoErr] = useState();
  const videoInputRef = useRef();
  const variantRef = useRef([]);
  const [tbyb, settbyb] = useState({ value: false, label: "NO" });
  const [exclusiveTag, setExclusiveTag] = useState({ value: false, label: "No" });
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [traitsEdit, setTraitsEdit] = useState(false);
  const [traits, setTraits] = useState(Traits);

  
 
  const schema = yup
    .object({
      variants: yup
        .array()
        .of(
          yup.object({
            inventoryQuantity: yup
              .string()
              .required("Quantity is a required field"),
            price: yup.number().required("Price is a required field"),
          })
        )
        .length(variants.length),
    })
    .required();

  const methods = useForm({
    values: {
      variants: variants.map((variant) => {
        const weight = variant.weight;
        const kilogram = Math.floor(weight);
        const gram = (weight - kilogram) * 1000;

        return {
          price: variant.price,
          weight,
          kilogram,
          gram: Number(gram.toFixed()),
          inventoryQuantity: variant.inventoryQuantity,
        };
      }),
    },
    resolver: yupResolver(schema),
    resetOptions: {
      keepDirtyValues: true,
    },
  });
  const {
    formState: { errors: formErrors },
    getValues,
    handleSubmit,
    setValue,
  } = methods;

  const currentCategory = prodCategories.find(
    (p) => p.label === selectedCategory
  );

  const {
    isLoading: isProductModelsLoading,
    data: { data: productModels } = { data: [] },
  } = useQuery(
    ["models", currentCategory?.value],
    () => getProductModels(currentCategory.value),
    {
      enabled: currentCategory != null,
    }
  );

  const { isLoading: isVideoMetaFields, data: videoMetaFields } = useQuery(
    ["productMetaFields", productId],
    async () => {
      const productMetaFields = await getProductMetaFields(productId);
      const videoMetaFields = productMetaFields
        ? productMetaFields.filter(
            (m) => m.key === "videourl" && m.value !== "null"
          )
        : [];
      return videoMetaFields;
    },
    {
      enabled: productId != null,
      initialData: []
    }
  );

  const {
    isLoading: isProductWeightsLoading,
    data: { data: productWeights } = { data: [] },
  } = useQuery(
    ["weights", selectedCategory?.value],
    () => getProductWeights(currentCategory.value),
    {
      enabled: currentCategory != null,
    }
  );

  const {
    isLoading: isProductGradesLoading,
    data: { data: productGrades } = { data: [] },
  } = useQuery(
    ["grades", currentCategory?.value],
    () => getProductGrades(currentCategory.value),
    {
      enabled: currentCategory != null,
    }
  );

  const {
    isLoading: isProductDescriptionLoading,
    data: { data: storedDescription } = { data: null },
  } = useQuery(
    ["descriptions", selectedCategory?.value, selectedModel?.value],
    () => getProductDescription(currentCategory.value, selectedModel?.value),
    {
      enabled: currentCategory != null && selectedModel != null,
    }
  );

  useEffect(() => {
    // Only prefill the canned model description when the user picks a
    // different model; on load the product's own description must win
    if (storedDescription && selectedModel?.value !== modelId) {
      updateState({ description: storedDescription.title });
    }
  }, [storedDescription, selectedModel]);

  const updateState = (data) =>
    setState((prevState) => ({ ...prevState, ...data }));

  useEffect(() => {
    if (tryBeforeYouBuy) {
      settbyb({ value: true, label: "YES" });
    }
  }, [tryBeforeYouBuy]);
  useEffect(() => {
    
      setExclusiveTag({ value: isExclusive, label: isExclusive ? "YES" : "No" });
    
  }, [isExclusive]);

  useEffect(() => {
    if (productModels.length > 0) {
      const productModel = productModels.find((a) => a.id === modelId);
      if (productModel) {
        updateState({
          selectedModel: { value: productModel.id, label: productModel.name },
        });
      } else {
        updateState({
          selectedModel: null,
        });
      }
    }
  }, [productModels, modelId]);

  useEffect(() => {
    if (productGrades.length > 0) {
      const productGrade = productGrades.find((a) => a.id === gradeId);
      if (productGrade) {
        updateState({
          selectedGrade: { value: productGrade.id, label: productGrade.name },
        });
      } else {
        updateState({
          selectedGrade: null,
        });
      }
    }
  }, [productGrades, gradeId]);

  useEffect(() => {
    
    if (productWeights.length > 0) {
      const productWeight = productWeights.find((a) => a.weight === weightVal);
      if (productWeight) {
        updateState({
          selectedWeight: {
            value: productWeight.weight,
            label: productWeight.weight,
          },
        });
      } else {
        updateState({
          selectedWeight: null,
        });
      }
    }
  }, [productWeights, weightVal]);

  //if prop options change, update the local options state
  useEffect(() => {
    updateState({ options: productOptions });
    setSelectedOptions([]);
  }, [productOptions]);

  //if local options state changes, update the fields and selected options state
  useEffect(() => {
    if (productCategories?.length !== 0) {
        //getFieldHeadingsAndValues(selectedCategory);
    }
    if (options.length > 0) {
      const fieldOptions = bespokeBatOptions.map((field) => {
          const option = options.find((x) => x.name === field.heading);
          const { fieldValues } = field;
          const selectedField = fieldValues.find(
            (f) => f.label === option?.values[0]
          );
          if (option && selectedField) {
            return {
              ...field,
              ...{
                selectedOption: selectedField,
              },
            };
          } else {
            return {
              ...field,
              ...{
                selectedOption: null,
              },
            };
          }
      });

      updateState({fields : fieldOptions});

      setSelectedOptions(options.map(opt => {
        return ({
          heading: opt.name,
          selectedValue: opt.values[0]
        })
      }));
    }
  }, [options]);

  useEffect(() => {
    setNameError("");
    setDescError("");
    setPriceError("");
    setQuantityError("");
    setWeightError("");
    setImageError({});
    setInvalidData(false);
    updateState({
      productName: title,
      description: productDescription,
      productPrice: String(value),
      quantity: productQuantity,
      images: productImages,
      videos: productVideos,
      // videos: videoMetaFields,
      productId: id,
      selectedCategory: productCategory,
      productWeight: weightVal,
      productWeightUnit: weightUnitVal,
      variants: productVariants,
    });
    if (weightUnitVal === "lb") lbToOz(weightVal);
  }, [
    title,
    productDescription,
    value,
    productQuantity,
    productImages,
    id,
    productCategory,
    weightVal,
    weightUnitVal,
    productVideos,
    // videoMetaFields,
    productVariants,
  ]);

  const changeTextValues = (e, hasVariant=null) => {
   
      if(e.target.value < 1)
      {
        setInvalidData(true);
          setPriceError("Price cant be less than £1");
          
      }
      else{
        setPriceError("");
        setInvalidData(false);
      }
    updateState({ [e.target.name]: e.target.value });

    if(hasVariant==1){
      const updatedVariants=  variants.map((v) => {
           return { ...v, price:e.target.value };
       });
       updateState({ variants: updatedVariants });
     }
     if(hasVariant==2){
       const updatedVariants= variants.map((v) => {
           return { ...v, inventoryQuantity:e.target.value };
       });
       updateState({ variants: updatedVariants });
     }
  };

  const lbToOz = (lb) => {
    const afterDecimal = lb - Math.floor(lb);
    const poundToOunce = afterDecimal * 16;
    setOunces(Math.round(poundToOunce));
    updateState({ productWeight: Math.floor(lb) });
  };

  const getWeight = (lb, oz) => {
    if (productWeightUnit === "lb") {
      const ozToLb = oz / 16;
      const totalPounds = (Number(lb) + Number(ozToLb)).toFixed(2);
      return totalPounds.toString();
    }
    return productWeight;
  };

  const setSelectedProductModel = (option) => {
    updateState({ selectedModel: option });
  };
  const handleSelectedProductModelInputChange = (inputValue) =>{
    if(inputValue === null || inputValue === "" || inputValue === undefined) return;
    
    updateState({ selectedModel: {value:0, label:inputValue}, customModel: inputValue });
    
  };
  const setSelectedProductGrade = (option) => {
    updateState({ selectedGrade: option });
  };
  const handleSelectedProductGradeInputChange = (inputValue)=>{
    if(inputValue === null || inputValue === "" || inputValue === undefined) return;
    
    updateState({ selectedGrade: {value:0, label:inputValue}, customGrade: inputValue });
    
  };
  const setSelectedProductWeight = (option) => {
    updateState({ selectedWeight: option });
  };

  const setSelectedCategory = (option) => {
    updateState({ selectedCategory: option.label });
    setSelectedOptions([]);
    const { label } = option;
    if (label !== 0) {
      getFieldHeadingsAndValues(label);
    }
    if (batCategories.includes(option.label)) {
      updateState({ productWeightUnit: "lb" });
    } else {
      updateState({ productWeightUnit: "kg" });
    }
  };

  const setExistingOption = (heading, option) => {
    let selectedField = fields.find((m) => m.heading === heading);
    selectedField.selectedOption = option;
    const updatedFields = fields.map((m) =>
      m.heading !== heading.id ? m : selectedField
    );
    updateState({ fields: updatedFields });
    setOption(heading, option);
  };

  const setOption = (heading, option) => {
    setSelectedOptions((data) => [
      ...data.filter((m) => m.heading !== heading),
      { heading: heading, selectedValue: option.label },
    ]);
  };

  const getFieldHeadingsAndValues = async (categoryName) => {
    const res = await apiGet(`${GETFIELDSBYCATEGORYNAME}/${categoryName}`);
    if (res) {
      const { data } = res;
      const fieldOptions = data.map((m) => {
        const field = {
          id: m.id,
          heading: m.heading,
          fieldValues: m.fieldValues.map((e) => ({
            value: e.id,
            label: e.value,
          })),
        };
        if (productCategory === categoryName) {
          const option = options.find((x) => x.name === m.heading);
          const { fieldValues } = field;
          const selectedField = fieldValues.find(
            (f) => f.label === option?.values[0]
          );
          if (option && selectedField) {
            return {
              ...field,
              ...{
                selectedOption: selectedField,
              },
            };
          } else {
            return {
              ...field,
              ...{
                selectedOption: null,
              },
            };
          }
        } else {
          return field;
        }
      });
      updateState({ fields: fieldOptions });
    }
  };

  const onImageRemove = (deleteIndex) => {
    const allImages = images;

    const displayedImages = allImages.filter(image => image.isDeleted !== true);

    const imageToRemove = displayedImages[deleteIndex];

    const indexToRemove = allImages.indexOf(imageToRemove)
    console.log("indexes ---", deleteIndex, indexToRemove, imageToRemove);
    
    if (allImages[indexToRemove] && allImages[indexToRemove].id) {
      allImages[indexToRemove].isDeleted = true;

    }
    else{
      allImages.splice(indexToRemove, 1);
    }
    console.log("images ---", allImages, allImages.filter(image => image.isDeleted !== true));
    updateState({ images: allImages });
    if (imageError) imageError.index == deleteIndex && setImageError({});
    if (allImages.filter(image => image.isDeleted !== true).length === 0)
      
      setImageError({ message: Messages.validation.isEmpty });
    //Image_remove_event_log
    AnalyticsService.logEvent("PRODUCT_IMAGE_REMOVED_SUCCESSFULLY", {
      imageIndex: deleteIndex,
    });
  };

  const isValidData = () => {
    const nameErr = validator({ productName });
    const descErr = validator({ description });
    let priceErr = hasVariants ? false : validator({ productPrice });
    const quantityErr = hasVariants ? false : validator({ quantity });
    let weightErr;
    let ounceErr;
   
    let images = state.images;
 
    if (productWeightUnit === "lb") {
     
      ounceErr = hasVariants
        ? false : false
        // : validator({
        //     weight: selectedWeight?.value ?? null,
        //     weightUnit: "lb",
        //   });
      
    } else {
    
      weightErr = hasVariants
        ? false : false
        // : validator({
        //     weight: selectedWeight?.value ?? null,
        //     weightUnit: "kg",
        //   });
    }

    if (nameErr) {
      setNameError(nameErr);
      //Product_name_error_log
      AnalyticsService.logEvent("PRODUCT_NAME_ERROR", {
        Error: nameErr,
      });
    } else {
      setNameError("");
    }

    if (images.filter(image => image.isDeleted !== true).length === 0) {
    
      setImageError({ message: Messages.validation.isEmpty });
      //Product_Image_error_log
      AnalyticsService.logEvent("PRODUCT_Image_ERROR", {
        Error: Messages.validation.isEmpty,
      });

      setInvalidData(true);
     
      return false;
    } else {
      
      setImageError({});
    }

    if (descErr) {
      setDescError(descErr);
      //Product_description_error_log
      AnalyticsService.logEvent("PRODUCT_DESCRIPTION_ERROR", {
        Error: descErr,
      });
    } else {
      setDescError("");
    }
    if (priceErr) {
      setPriceError(priceErr);
      //Product_price_error_log
      AnalyticsService.logEvent("PRODUCT_PRICE_ERROR", {
        Error: priceErr,
      });
    } else {

        const hasZeroPrice = variants.some((variant) => parseFloat(variant.price) < 1);
        if(hasZeroPrice)
        {
          setPriceError("Variant price can't be less than £1");
          priceErr = true;
        }
        else
        {
          setPriceError("");
        }
      
    }
    if (quantityErr) {
      setQuantityError(quantityErr);
      //Product_quantity_error_log
      AnalyticsService.logEvent("PRODUCT_QUANTITY_ERROR", {
        Error: quantityErr,
      });
    } else {
      setQuantityError("");
    }
    if (weightErr) {
      setWeightError(weightErr);
      AnalyticsService.logEvent("PRODUCT_WEIGHT_ERROR", {
        Error: weightErr,
      });
    } else if (ounceErr) {
      setWeightError(ounceErr);
      AnalyticsService.logEvent("PRODUCT_WEIGHT_ERROR", {
        Error: ounceErr,
      });
    } else {
      setWeightError("");
    }

    if (
      nameErr ||
      descErr ||
      priceErr ||
      quantityErr ||
      weightErr ||
      priceError ||
      ounceErr ||
      videoErr ||
      imageError.message ||
      hasFormErrors(formErrors)
    ) {
     
      setInvalidData(true);
      return false;
    } else {
      setInvalidData(false);
      return true;
    }
  };

  const onImageChange = async (imageList, addUpdateIndex) => {
    setIsImageLoading(true);
    setImageError({});
    let images_ = [];

    const deletedImages = images.filter(image => image.isDeleted === true)
    imageList = [...imageList, ...deletedImages];

    for (let index = 0; index < imageList.length; index++){
      const img = imageList[index];
      
      if (img.data_url) {
        let newImage = new Image();
        newImage.src = URL.createObjectURL(img.file);
        
        images_ = await loadImage(imageList, img, newImage, images_);
        
        
        
      } else {
        images_.push(img);
      }
    };

    updateState({ images: images_ });
    setIsImageLoading(false);
  };

  const loadImage = async (imageList, img, newImage, imageArray) => {
    return new Promise((resolve) => {
      newImage.onload = async () => {
        let megaPixels = (newImage.width * newImage.height) / 1000000;
  
        if (imageList.length > 0) {
          if (megaPixels > 19) {
            let resizedImage = new Image();
            
            let fileToResize = img.file;
            let maxWidth = 3000;
            let maxHeight = 4000;
  
            const imageResizer = ImageResizer(fileToResize, maxWidth, maxHeight);
            try {
              const resizedImageBlob = await imageResizer.resizeImage();
              resizedImage.src = URL.createObjectURL(resizedImageBlob);
              newImage.width = maxHeight;
              newImage.height = maxHeight;
              const sizeInMb = (resizedImageBlob.size / 1024) / 1024;
              
  
              const resizedImageUrl = await LoadResizedImage(resizedImageBlob, resizedImage);
              
  
              imageArray.push({
                productId: productId,
                src: resizedImage.src,
                fileName: img.file.name,
                fileType: img.file.type,
                attachment: resizedImageUrl.split(";")[1].split(",")[1],
              });
            } catch (error) {
              
            }
          } else {
            imageArray.push({
              productId: productId,
              src: newImage.src,
              fileName: img.file.name,
              fileType: img.file.type,
              attachment: img.data_url.split(";")[1].split(",")[1],
            });
          }
        }
  
        resolve(imageArray);
      };
    });
  };
  const LoadResizedImage = async (resizedImageBlob, resizedImage) =>{
    return new Promise((resolve) => {
      resizedImage.onload = async () => {
       
  
        const dataURL = await new Promise((innerResolve) => {
          const reader = new FileReader();
          reader.onloadend = () => innerResolve(reader.result);
          reader.readAsDataURL(resizedImageBlob);
        });
  
        resolve(dataURL);
      };
    });
  };
//   const resizeImages = async (images) => {
//     images.forEach
//  };
  const saveForm = async () => {

    if(hasPriceChange && isTopDeal)
    {
      toast.success('We have detected a price change for a top deal product, please note that we will remove this product from the top deal campaign', {
        autoClose: 10000, 
      });
    }
    updateState({ isLoading: true });
    let op1, op2, op3;
    // let options = batCategories.includes(selectedCategory)
    //   ? selectedOptions
    //   : optionsByCategory[selectedCategory];
    //console.log(selectedOptions);
    let options = selectedOptions;
    let updatedProductOptions = [];
    //let options = optionsByCategory[selectedCategory];
    const category = productCategories?.find(
      (c) => c.name === selectedCategory
    );
    const checkValid = isValidData();
    if (checkValid && !imageError.index) {
      if (bespokeCategoryName ===  selectedCategory) {
        if (options.length > 1 && options.find((m) => m.heading === "Title")) {
          options = options.filter((m) => m.heading !== "Title");
          setSelectedOptions(options);
        }
        options.map((m, i) => {
          updatedProductOptions.push({
            productId: productId,
            name: m.heading,
            position: i + 1,
            values: [m.selectedValue],
          });
          if (i === 0) {
            op1 = m.selectedValue;
          }
          if (i === 1) {
            op2 = m.selectedValue;
          }
          if (i === 2) {
            op3 = m.selectedValue;
          }
        });
      } else {
        updatedProductOptions = options;
      }

    
    const productVideos = videos.map((video) => {
      // console.log("base64", video.videob64);
      return {
        id: video.id,
        productId: video.productId,
        isAdded: video.isAdded,
        isDeleted: video.isDeleted,
        src: "",
        fileName: video.videoName,
        fileType: video.videoType,
        attachment: "",
        base64Chunk: video.videob64,
      };
    });
  
    const newProduct = {
      categoryId: category?.id,
      productId: productId,
      modelId: selectedModel?.value,
      gradeId: selectedGrade?.value,
      customGrade: customGrade,
      customModel: customModel,
      title: productName,
      description: description,
      vendor: userName,
      product_Type: "string",
      status: "active",
      tag: selectedCategory || productCategory,
      images: images,
      videos: productVideos,
      tbyb: tbyb.value,
      isExclusive: exclusiveTag.value,
      hasPriceChange: hasPriceChange
    };

    newProduct.options = updatedProductOptions;
    if (variants.length !== 0 && bespokeCategoryName !== selectedCategory) {
      newProduct.variants = variants.map((variant) => {
        return {
          id: variant.id,
          productId: productId,
          fulfillmentService: "manual",
          inventoryManagement: "shopify",
          inventoryItemId: variant.inventoryItemId,
          weight: variant.weight,
          weightUnit: productWeightUnit,
          inventoryQuantity: variant.inventoryQuantity
            ? Number(variant.inventoryQuantity)
            : Number(0),
          price: variant.price ? Number(variant.price) : Number(productPrice),
          ...(variant.option1 && { option1: variant.option1 }),
          ...(variant.option2 && { option2: variant.option2 }),
          ...(variant.option3 && { option3: variant.option3 }),
        };
      });
    } else {
      const variantId = variants[0].id;
      const inventoryItemId = variants[0].inventoryItemId;
      newProduct.variants = [
        {
          id: variantId,
          productId: productId,
          weight: selectedWeight?.value,
          inventoryItemId: inventoryItemId,
          weightUnit: productWeightUnit,
          inventoryManagement: "shopify",
          fulfillmentService: "manual",
          inventoryQuantity: Number(quantity),
          price: Number(productPrice),
          ...(op1 && { option1: op1 }),
          ...(op2 && { option2: op2 }),
          ...(op3 && { option3: op3 }),
        },
      ];
    }
    
   

    const res = await apiPost(UPDATEPRODUCT, newProduct);
   
    updateState({ isLoading: false });
    await getProducts();
    setShowProduct(false);
    setShowList(true);
    //Product_updated_event_log
    AnalyticsService.logEvent("PRODUCT_UPDATED_SUCCESSFULLY", {
      ProductName: productName,
      title: productName,
      description: description,
      vendor: userName,
      status: "active",
      tag: selectedCategory?.label ? selectedCategory.label : productCategory,
    });
  }
  updateState({ isLoading: false });
}

  const deleteProduct = async () => {
    const res = await apiDelete(DELETEPRODUCT, { productId });
    onCloseModal();
    if (res) {
      setShowProduct(false);
      setShowList(true);
      //Product_deleted_event_log
      AnalyticsService.logEvent("PRODUCT_DELETED_SUCCESSFULLY", {
        ProductName: productName,
      });
      await getProducts();
    }
  };

  const ImageLayout = (props) => {
    const { className, overlayClass, src, onClick } = props;
    return (
      <div className={className}>
        <div className={overlayClass} />
        <img src={src} className="formImg" />
        <IconButton onClick={onClick} className="imageRemoveCls" />
      </div>
    );
  };

  const onVideoRemove = useCallback(
    ({ tempId, id }) => {
      let allVideos = [];
      if (id) {
        allVideos = videos.map((video) => {
          if (video.id) {
            return { ...video, isDeleted: true };
          }
          return video;
        });
      } else {
        allVideos = videos.filter((v) => v.tempId !== tempId);
      }
      updateState({ videos: [...allVideos] });

      if (allVideos.length === 0) {
        setVideoErr("");
      }
    },
    [videos]
  );

  const updateVariant = (variant) => {
    
    const updatedVariants = variants.map((v) => {
      if (
        v.option1 === variant.option1 &&
        v.option2 === variant.option2 &&
        v.option3 === variant.option3
      ) {
          if(v.price != variant.price)
          {
            updateState({hasPriceChange: true});
          }
        return { ...v, ...variant };
      }
      return v;
    });
    updateState({ variants: updatedVariants });
  };

  const onImageChangeUpdate = (imageList) => {
    
    const deletedImages = images.filter(image => image.isDeleted === true);
   
    updateState({ images: [...imageList, ...deletedImages] });
  };
  const getVideoPlaytime = (file) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = () => {
        resolve(video.duration);
      };
      video.onerror = (error) => {
        reject(error);
      };
      video.src = URL.createObjectURL(file);
    });
  };
  const categoryLabel = selectedCategory
    ? selectedCategory
    : prodCategories[0]?.label;

  const weightTitle = `Weight (${
    batCategories.includes(categoryLabel) ? "lb" : categoryLabel ? "kg" : ""
  })`;
  
  const hasVariants = variants.length > 1 || categoryLabel != bespokeCategoryName;

  const handleTraitSave = (traits)=>{
    setTraits(traits);
    setTraitsEdit(false);
  }

  return (
    <FormProvider {...methods}>
      {traitsEdit ? (
        <TraitsInput
          onCancel={()=>{setTraitsEdit(false)}}
          onSave={(traits)=>{handleTraitSave(traits)}}
          Traits={traits}
        />) :(<div>{selectedVariant ? (
        <VariantEdit
          isBat={batCategories.includes(categoryLabel)}
          weightTitle={weightTitle}
          variant={selectedVariant}
          productWeights={productWeights}
          onCancelClick={() =>{
             const refIndex = selectedVariant.index;
             setSelectVariant(null);
             setTimeout(() => {
              const ref = variantRef.current[refIndex];
              if(ref)
                {
                  ref.focus();
                  
                }
               
            }, 100);
            }}
          onSave={() => {
            const { variants } = getValues();
            const variant = variants[selectedVariant.index];

          
            setValue(
              `variants[${selectedVariant.index}].weight`,
              variant.weight,
              { shouldValidate: true }
            );
            updateVariant({
              ...selectedVariant,
              ...variants[selectedVariant.index],
            });
            setSelectVariant(null);

            setTimeout(() => {
              const ref = variantRef.current[selectedVariant.index];
              if(ref)
                {
                  ref.focus();
                 
                }
               
            }, 100);
           
          }}
        />
      ) : (
        <div className="formLayer">
          {invalidData && (
            <div className="desktopOnly">
              <ErrorWrapper text="Please complete missing fields to save this item." />
            </div>
          )}
          <div className="formLayer0">
            <Title text={"Edit item"} className="addItemCls" />
            <Stack direction={"row"} spacing={1} className="productTripleLayer">
              <ActionButton2
                text="CANCEL"
                onClick={onCancelClick}
                className="productSaveECls"
              />
             {!isTabletOrMobile&&  <ActionButton2
                text="SAVE"
                onClick={handleSubmit(saveForm)}
                className="productSaveCls greenSecBtn"
                isLoading={isLoading}
                marginTop={3}
                disabled={isLoading}
              />}
              <ActionButton2
                text="DELETE"
                onClick={onOpenModal}
                className="productDelCls"
              />
            </Stack>
          </div>
          <div className="innerScroll">
          <div className="formLayer1" id="categorySelection">
            <Title text={"Category"} className="formLabelCls" />
            <Select
              placeholder={selectedCategory}
              isSearchable={false}
              value={selectedCategory}
              onChange={(option) => setSelectedCategory(option)}
              options={prodCategories}
              id="editCategorId"
            />
          </div>
          <div className="formLayer1" id="categorySelection">
            <Title text={"Model"} className="formLabelCls" />
            <Select
              placeholder={selectedModel}
              isSearchable={true}
              value={selectedModel}
              onChange={(option) => setSelectedProductModel(option)}
              options={productModels.map((m) => ({
                value: m.id,
                label: m.name,
              }))}
              id="editCategorId"
              onInputChange={handleSelectedProductModelInputChange}
            />
          </div>

          <div className="formLayer1" id="categorySelection">
            <Title text={"Grade"} className="formLabelCls" />
            <Select
              placeholder={selectedGrade}
              isSearchable={true}
              value={selectedGrade}
              onChange={(option) => setSelectedProductGrade(option)}
              options={productGrades.map((m) => ({
                value: m.id,
                label: m.name,
              }))}
              id="editCategorId"
              onInputChange={handleSelectedProductGradeInputChange}
            />
          </div>
          

          {categoryLabel === "Workshop Cricket Bats" && (
            <div className="formLayer1" id="categorySelection">
              <Title text={"TBYB"} className="formLabelCls" />
              <Select
                value={tbyb}
                onChange={settbyb}
                options={[
                  { value: true, label: "YES" },
                  { value: false, label: "NO" },
                ]}
              />
            </div>
          )}
          <div className="formLayer1">
            <Title text={"Product name"} className="formLabelCls" />
            <TextField
              name="productName"
              className="productField"
              value={productName}
              onChange={changeTextValues}
              isError={nameError}
              errorText={nameError}
            />
          </div>
          <div className="formLayer1" id="categorySelection">
            <Title text={"Exclusive"} className="formLabelCls" />
            <Select
              placeholder={exclusiveTag}
              
              value={exclusiveTag}
              onChange={setExclusiveTag}
              options={[
                { value: true, label: "YES" },
                { value: false, label: "NO" },
              ]}
             
            />
          </div>
          <div className="formLayer2Add">
            <div className="inforLayerCls">
              <div className="imgUploadInfo">
                <Title text={"Images"} className="formLabelCls" />
                <Title text={"(10 images max)"} className="subInfoLabel" />
              </div>
              <Title
                text={Messages.label.imageSizeInfo}
                className="infoLabel"
              />
            </div>
            <div
              className={`imgLayerCls ${
                imageError.message ? "border-error" : ""
              }`}
            >
              <ImageUploading
                value={images.filter(image => image.isDeleted !== true)}
                onChange={onImageChange}
                dataURLKey="data_url"
                maxFileSize={157286400}
                acceptType={["png", "jpg", "jpeg"]}
                multiple
                maxNumber={10}
                
              >
                {({
                  imageList,
                  onImageUpload,
                  dragProps,
                  isDragging,
                  errors,
                }) => (
                  <>
                    <div className="imageGrid" {...dragProps}>
                      {isDragging && ""}
                      <SecondaryButton
                        
                        text={images.length >= 10 ? "Max Exceeded" : "ADD"}
                        className="addFormCls"
                        onClick={onImageUpload}
                        disabled={images.length === 10 ? true : false}
                        style={{  display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center' }}
                      />
                      <Title
                        text={"Insert up to 10 images"}
                        className={"insertLabel"}
                      />
                     
                    </div>
                    {errors && (
                      <div>
                        {errors.maxFileSize && (
                          <span className="errorTexCls">
                            Selected image size exceed 10MB
                          </span>
                        )}
                        {errors.resolution && (
                          <span className="errorTexCls">
                            Selected image resolution exceed 20MP
                          </span>
                        )}
                        {errors.maxNumber && (
                          <span className="errorTexCls">
                            Number of selected images exceed max (10) allowed
                            images.
                          </span>
                        )}
                        {errors.acceptType && (
                          <span className="errorTexCls">
                            Selected file type is not allowed.
                          </span>
                        )}
                      </div>
                    )}
                  </>
                )}
              </ImageUploading>
            </div>
          </div>

          <div style={{ paddingTop: 10 }}>
          {isImageLoading ? (
        
        <CircularProgress style={{ margin: 'auto', display: 'block' }}/>
      ) : (
        
        <DndProvider backend={HTML5Backend}>
          <Container
            dragData={state.images.filter(image => image.isDeleted !== true)}
            onImageRemove={onImageRemove}
            onImageChangeUpdate={onImageChangeUpdate}
          />
        </DndProvider>
      )}
          </div>

          <div className="imgError-desktop">
            <ErrorText text={imageError.message} />
          </div>
          <div className="formLayer2Add">
            <div className="inforLayerCls">
              <div className="imgUploadInfo">
                <Title text={"Videos"} className="formLabelCls" />
                <Title text={"Video file cant exceed 100MB"} className="subInfoLabel" />
              </div>
              <Title
                text={Messages.label.imageSizeInfo}
                className="infoLabel"
              />
            </div>
            <div className="imgLayerCls">
              <input
                ref={videoInputRef}
                type="file"
                accept="video/mp4"
                multiple={false}
                onChange={async (e) => {
                  if (!e.target.files) return;
                  setVideoErr();
                  for (const file of e.target.files) {
                    const playtime = await getVideoPlaytime(file);

                    if(playtime > 600)
                    {
                      setVideoErr("Selected video playtime is above 10 minutes please select another video");
                      return;
                    }
                  }
                  const fileList = await getListFiles(
                    e.target.files,
                    "data_url"
                  );
                  const videoFiles = fileList
                    .map((f) => toVideoData(f))
                    .map((v) => ({ ...v, isAdded: true }));

                  const updatedFileList = [...videos, ...videoFiles];
                  updateState({ videos: updatedFileList });

                  const fileSize = e.target.files[0].size;

                  if (fileSize > 150000000) {
                    setVideoErr("Video should be smaller than 150MB");
                    return;
                  } else {
                    setVideoErr("");
                  }
                  
                  e.target.value = null;
                }}
                style={{ display: "none" }}
              />
              <div className="imageGrid">
                <SecondaryButton
                  text={"ADD"}
                  className="addFormCls"
                  onClick={() => {
                    videoInputRef.current.click();
                  }}
                  disabled={(videos.filter(video => video.isAdded).length >= 1)}
                />
                <Title
                  text={""}
                  className={"insertLabel"}
                />

                {videos
                  .filter((v) => !v.isDeleted)
                  .map((video) => {
                    return (
                      <VideoLayout
                        key={video.id || video.tempId}
                        idx={video.id || video.tempId}
                        className={"firstIndexImage"}
                        overlayClass={"overlayFirstIndex"}
                        src={video.id ? video.value : video.src}
                        onClick={() =>
                          onVideoRemove({ tempId: video.tempId, id: video.id })
                        }
                      ></VideoLayout>
                    );
                  })}
              </div>
            </div>
            {videoErr && <ErrorText text={videoErr} />}
          </div>
          <div className="formLayer1T marginTop">
            <Title text={"Description"} className="formLabelCls" />
            <TextAreaInput
              name="description"
              value={strippedString}
              onChange={changeTextValues}
              isError={descError}
              errorText={descError}
            />
          </div>
            {categoryLabel === "Memorabilias" && <div className="formLayer1T marginTop">
              
              <ActionButton2
              text="Edit Traits"
              onClick={()=>{setTraitsEdit(true)}}
              className="productSaveMobile"
              
              //isLoading={isLoading}
              marginTop={1}
              //disabled={isLoading}
            />
            </div>}
          <div className="formLayer3">
                <Title text={!hasVariants ?"Price (£)":"General Price (£)"} className="formLabelCls" />
                <TextField
                  name="productPrice"
                  className="productField1"
                  type="number"
                  value={productPrice}
                  onChange={(e)=>changeTextValues(e,hasVariants?1:null)}
                  isError={priceError}
                  errorText={priceError}
                />
              </div>
              <div className="formLayer3">
                <Title text={!hasVariants ? "Quantity":"General Quantity"} className="formLabelCls" />
                <TextField
                  name="quantity"
                  type="number"
                  className="productField1"
                  value={quantity}
                  onChange={(e)=>changeTextValues(e,hasVariants?2:null)}
                  isError={quantityError}
                  errorText={quantityError}
                />
              </div>
          {variants && variants.length > 0 && bespokeCategoryName !== categoryLabel ? (
            <div className="mt-1">
              <Title text={"Variants"} className="formLabelCls" />
              <div>
              {variants.map((variant, index) => {
                
                return (
                  <div  key={variant.id} ref={(ref) => {variantRef.current[index] = ref;}} tabIndex={0}>
                    <VariantItem
                     
                      
                      variant={variant}
                      onClick={() => {
                        setSelectVariant({ ...variant, index });
                      }}
                      error={formErrors?.variants?.[index]}
                    />
                  </div>
                );
              })}
              </div>
            </div>
          ) : null}
          {/* {bespokeCategoryName === categoryLabel && (
            <>
              
            </>
          )} */}
          {bespokeCategoryName === categoryLabel &&
            fields.length > 0 &&
            fields.map((f) => {
              
              return (
                <div className="formLayer3" key={f.id}>
                  <div className="subInfoParent">
                    <Title text={f.heading} className="formLabelCls" />
                  </div>
                  <Select
                    value={f.selectedOption}
                    isSearchable={false}
                    placeholder={"Please select"}
                    onChange={(option) => setExistingOption(f.heading, option)}
                    options={f.fieldValues}
                    styles={{
                      menuList: (styles) => ({
                        ...styles,
                        maxHeight: 160,
                      }),
                    }}
                  />
                </div>
              );
            })}

          {/* <div className="formLayer3">
        <Title text={"Try before you buy"} className="formLabelCls" />
        <Select
          defaultValue={
            tryBeforeYouBuy === true
              ? { label: "Yes", value: tryBeforeYouBuy }
              : { label: "No", value: tryBeforeYouBuy }
          }
          isDisabled={true}
          isSearchable={false}
        />
      </div> */}
      </div>
          <div className="mobileOnly">
            {invalidData && (
              <ErrorWrapper text="Please complete missing fields to save this item." />
            )}
            <ActionButton
              text="SAVE"
              onClick={saveForm}
              className="productSaveMobile"
              isLoading={isLoading}
              marginTop={3}
              disabled={isLoading}
            />
          </div>
          <Modal open={open} showCloseIcon={false} center>
            <ConfirmationContent
              onCancel={onCloseModal}
              onConfirm={deleteProduct}
              title={"Delete item"}
              content={`You are about to delete ${productName}`}
              subContent={"This action can’t be undone."}
            />
          </Modal>
        </div>
        )}</div>)}
      
    </FormProvider>
  );

  
};
